import React from "react";
import RohsHeader from "../../../components/Compliance Certificates/RoHS/RohsHeader";
import RohsInfoContainer from "../../../components/Compliance Certificates/RoHS/RohsInfoContainer";

const RoHS = () => {
  return (
    <div>
      <RohsHeader />
      <RohsInfoContainer />
    </div>
  );
};

export default RoHS;
